export default __webpack_public_path__ + "static/media/demonwarlord.07df2fef.png";